import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5hpmatuy6: FaireProductEntity = {
  token: "p_s5hpmatuy6",
  type: "product",
  name: "Italian Charm Bracelet Starter - 316L Stainless Steel",
  brandToken: "b_kqast86cfn",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/5775803a02f2feed6c0e77735fe6cb12cea28a0fed22a4e610549e69d9784f83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31b9ab3a14b0eed5a32990dc07be8d3a2240f4018f59d0808f783655d6e1f221.jpeg",
    "https://cdn.faire.com/fastly/a9e05b714dbc24f5aec8f6f5e71310e0ff7d6bd8f333a3b8467eab22e736e47c.jpeg",
    "https://cdn.faire.com/fastly/35245025aebf3dad9903bca04184c2eca2a2cd6175e43fc811d06656a5c30735.jpeg",
    "https://cdn.faire.com/fastly/dec3b13ff96e1aca03f5226c5c39cb0e1babee4eec59d977c983517280622f49.jpeg",
    "https://cdn.faire.com/fastly/c56d8344142734a7bb877851836aaf2814717b969cbd931fe276a91f3bea9e7b.jpeg",
  ],
  priceDollars: 2,
  description:
    '* Modular Italian link bracelet\n* Blank starter Italian charm bracelet\n* UNIT= PC\n* Removable charms to create your own personalized bracelet\n* Made of 316L stainless steel\n* 7" length - 18 links\n* Each link is 9mm in size to fit all standard Italian charm bracelets\n* Add or remove the stretchable links for the perfect fit\n* Additional charm styles sold separately\n\nPerfect for jewelry stores, fashion boutiques, and gift shops.',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.527Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
